import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — escucha cambios de ruta y hace `scrollTo(0, 0)` para que
 * cada navegación arranque arriba (UX consistente con el resto de
 * surfaces). ROUND10 #5.
 *
 * No renderea nada. Se monta una sola vez en `AppShell`.
 *
 * Solo reacciona a cambios de `pathname` (no a `search` ni `hash`) para
 * preservar el anchor scrolling (`#sección`) y la paginación por query
 * params en la misma página.
 */
export function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // `behavior: 'instant'` evita la animación al navegar entre rutas;
    // queremos un teletransporte a 0,0, no un scroll animado lento.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
